import { render } from "./vnewfanscoupon.vue?vue&type=template&id=cacdd2ea&scoped=true"
import script from "./vnewfanscoupon.vue?vue&type=script&lang=js"
export * from "./vnewfanscoupon.vue?vue&type=script&lang=js"

import "./vnewfanscoupon.vue?vue&type=style&index=0&id=cacdd2ea&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cacdd2ea"]])

export default __exports__